var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Material ui Imports
import { CancelRounded } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle, useTheme, } from "@mui/material";
import VTButton from "./VTButton";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTButton use for web development to replace the material ui dialog
//--------Does not support light mode
export default function VTDialog(_a) {
    var title = _a.title, primaryArea = _a.primaryArea, open = _a.open, handleClose = _a.handleClose, children = _a.children, sx = _a.sx, _b = _a.size, size = _b === void 0 ? "lg" : _b, _c = _a.disablePortal, disablePortal = _c === void 0 ? false : _c, container = _a.container, hideBackdrop = _a.hideBackdrop, props = __rest(_a, ["title", "primaryArea", "open", "handleClose", "children", "sx", "size", "disablePortal", "container", "hideBackdrop"]);
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    var theme = useTheme();
    //-------------------------------------------------------------------------------------------------
    // ## Render ##
    return (_jsxs(Dialog, __assign({}, props, { hideBackdrop: hideBackdrop, container: container, disablePortal: disablePortal, onClose: function () {
            handleClose();
        }, open: open, fullWidth: true, maxWidth: size, sx: sx }, { children: [_jsx(VTButton, __assign({ type: "icon", onClick: function () {
                    handleClose();
                }, sx: { position: "absolute", top: 10, right: 10 } }, { children: _jsx(CancelRounded, {}) })), title && (_jsx(DialogTitle, __assign({ sx: {
                    minHeight: 15,
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                } }, { children: title }))), _jsx(DialogContent, __assign({ sx: { marginTop: "28px" } }, { children: children })), primaryArea && _jsx(DialogActions, { children: primaryArea })] })));
}
